import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import AIProviderModal from '../components/AIProviderModal';
import Tooltip from '../components/Tooltip';
import { getApiBaseUrl } from '../utils/apiConfig';

const PROVIDER_META = {
  openai: { label: 'OpenAI', description: 'Industry-leading GPT models for text analysis and reasoning' },
  azure: { label: 'Azure OpenAI', description: 'Enterprise-grade OpenAI models hosted on Microsoft Azure' },
  anthropic: { label: 'Anthropic', description: 'Claude models built for safety, accuracy, and nuance' },
  gemini: { label: 'Google Gemini', description: 'Google\'s multimodal AI models, fast and efficient' },
  grok: { label: 'xAI Grok', description: 'Real-time reasoning models by xAI with latest knowledge' },
};
const PROVIDER_ORDER = ['openai', 'azure', 'anthropic', 'gemini', 'grok'];

const ProviderIcon = ({ provider, size = 16 }) => {
  const iconColor = '#04041A';
  const s = size;
  if (provider === 'openai') {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.98 4.18a5.985 5.985 0 0 0-4 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872v.024zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66v.018zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681l-.004 6.722zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" fill={iconColor}/>
      </svg>
    );
  }
  if (provider === 'anthropic') {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.304 3H13.68l6.696 18h3.624L17.304 3zM6.696 3 0 21h3.624l1.368-3.816h7.008L13.368 21H17L10.304 3H6.696zm.672 11.16L9.504 8.28l2.136 5.88H7.368z" fill={iconColor}/>
      </svg>
    );
  }
  if (provider === 'gemini') {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 24A14.304 14.304 0 0 0 0 12 14.304 14.304 0 0 0 12 0a14.304 14.304 0 0 0 12 12 14.304 14.304 0 0 0-12 12z" fill={iconColor}/>
      </svg>
    );
  }
  if (provider === 'grok') {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.982 10.622 20.54 3h-1.554l-5.693 6.618L8.745 3H3.5l6.876 10.007L3.5 21h1.554l6.012-6.989L15.868 21H21.1l-7.118-10.378Zm-2.128 2.474-.697-.997L5.64 4.16h2.386l4.474 6.4.697.996 5.815 8.318h-2.387l-4.745-6.787-.026.009Z" fill={iconColor}/>
      </svg>
    );
  }
  if (provider === 'azure') {
    return (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.16 3 2 18.59l3.6.38L8.16 3zm.99 1.28L12 14.03l-4.92 5.79h9.93L9.15 4.28z" fill={iconColor}/>
        <path d="M14.5 5.63 22 18.97h-5.37L14.5 5.63z" fill={iconColor}/>
      </svg>
    );
  }
  return null;
};

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#04041A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="#575c61" strokeWidth="2" />
    <path d="M12 11v6" stroke="#575c61" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 7h.01" stroke="#575c61" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const Integrations = () => {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [integrations, setIntegrations] = useState(null);
  const [modelCatalog, setModelCatalog] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [modalProvider, setModalProvider] = useState(null);

  // Default model dropdown
  const [modelDropdownOpen, setModelDropdownOpen] = useState(false);
  const modelDropdownRef = useRef(null);

  // Embedding model dropdown
  const [embeddingDropdownOpen, setEmbeddingDropdownOpen] = useState(false);
  const embeddingDropdownRef = useRef(null);
  const [embeddingModelCatalog, setEmbeddingModelCatalog] = useState({});
  const [embeddingCapableProviders, setEmbeddingCapableProviders] = useState([]);

  const [slackCallbackError, setSlackCallbackError] = useState('');
  const slackCallbackHandled = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (modelDropdownRef.current && !modelDropdownRef.current.contains(e.target)) {
        setModelDropdownOpen(false);
      }
      if (embeddingDropdownRef.current && !embeddingDropdownRef.current.contains(e.target)) {
        setEmbeddingDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Slack OAuth callback
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (!code || state !== 'slack' || slackCallbackHandled.current) return;
    slackCallbackHandled.current = true;
    const handleSlackCallback = async () => {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('user');
      if (!token || !userData) { setSlackCallbackError('Please log in again.'); return; }
      const parsedUser = JSON.parse(userData);
      const firstOrg = parsedUser.organizations?.[0];
      const organizationId = firstOrg?.organizationId ?? firstOrg?.id ?? firstOrg?._id;
      if (!organizationId) { setSlackCallbackError('No organization found.'); slackCallbackHandled.current = false; return; }
      const orgId = typeof organizationId === 'string' ? organizationId : String(organizationId);
      try {
        const apiUrl = getApiBaseUrl();
        await axios.post(`${apiUrl}/integrations/slack/callback`, { code, organizationId: orgId }, { headers: { Authorization: `Bearer ${token}` } });
        window.history.replaceState({}, '', '/integrations');
        setSlackCallbackError('');
        navigate('/dashboard', { replace: true });
      } catch (err) {
        const msg = err.response?.data?.message;
        const slackErr = err.response?.data?.error;
        setSlackCallbackError(slackErr ? `${msg || 'Slack error'}: ${slackErr}` : (msg || 'Failed to connect Slack.'));
        slackCallbackHandled.current = false;
      }
    };
    handleSlackCallback();
  }, [location.search, navigate]);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData && userData !== 'undefined') {
      try {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
        if (parsedUser.organizations?.length > 0) fetchOrganization(parsedUser.organizations[0].organizationId);
      } catch { /* ignore */ }
    } else {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => { if (organization) { fetchIntegrations(); fetchModelCatalog(); } }, [organization]);

  const fetchOrganization = async (organizationId) => {
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiBaseUrl();
      const response = await axios.get(`${apiUrl}/organization/${organizationId}`, { headers: { Authorization: `Bearer ${token}` } });
      setOrganization(response.data);
    } catch (error) { console.error('Error fetching organization:', error); }
  };

  const fetchIntegrations = async () => {
    if (!organization) return;
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiBaseUrl();
      const response = await axios.get(`${apiUrl}/ai-providers/${organization._id || organization.id}`, { headers: { Authorization: `Bearer ${token}` } });
      setIntegrations(response.data);
    } catch (error) { console.error('Error fetching integrations:', error); }
    finally { setIsLoading(false); }
  };

  const fetchModelCatalog = async () => {
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiBaseUrl();
      const response = await axios.get(`${apiUrl}/ai-providers/models`, { headers: { Authorization: `Bearer ${token}` } });
      setModelCatalog(response.data.models || {});
      setEmbeddingModelCatalog(response.data.embeddingModels || {});
      setEmbeddingCapableProviders(response.data.embeddingCapableProviders || []);
    } catch (error) { console.error('Error fetching model catalog:', error); }
  };

  const handleDisableProvider = async (providerName) => {
    const label = PROVIDER_META[providerName]?.label || providerName;
    if (!window.confirm(`Are you sure you want to disable ${label}?`)) return;
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiBaseUrl();
      await axios.put(`${apiUrl}/ai-providers/${organization._id || organization.id}/provider/${providerName}`, { enabled: false, apiKey: null }, { headers: { Authorization: `Bearer ${token}` } });
      fetchIntegrations();
    } catch (error) { console.error('Error disabling provider:', error); alert(`Failed to disable ${label}`); }
  };

  const handleSelectDefault = async (provider, modelId) => {
    setModelDropdownOpen(false);
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiBaseUrl();
      await axios.put(`${apiUrl}/ai-providers/${organization._id || organization.id}/default`, { provider, model: modelId }, { headers: { Authorization: `Bearer ${token}` } });
      fetchIntegrations();
    } catch (error) { console.error('Error setting default:', error); }
  };

  const isProviderEnabled = (name) => integrations?.providers?.[name]?.enabled || false;
  const enabledProviders = PROVIDER_ORDER.filter((p) => isProviderEnabled(p));

  const modelsForProvider = (pName) => {
    if (pName === 'azure') {
      const dep = integrations?.providers?.azure?.deploymentName;
      return dep ? [{ id: dep, name: dep }] : [];
    }
    return modelCatalog[pName]?.filter((m) => m.id !== '__custom__') || [];
  };

  const handleSelectEmbedding = async (provider, modelId) => {
    setEmbeddingDropdownOpen(false);
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiBaseUrl();
      await axios.put(`${apiUrl}/ai-providers/${organization._id || organization.id}/default-embedding`, { provider, model: modelId }, { headers: { Authorization: `Bearer ${token}` } });
      fetchIntegrations();
    } catch (error) { console.error('Error setting embedding model:', error); }
  };

  const embeddingModelsForProvider = (pName) => {
    if (pName === 'azure') {
      const dep = integrations?.providers?.azure?.deploymentName;
      return dep ? [{ id: dep, name: dep }] : [];
    }
    return (embeddingModelCatalog[pName] || []).filter((m) => m.id !== '__custom__');
  };

  const enabledEmbeddingProviders = embeddingCapableProviders.filter((p) => isProviderEnabled(p));

  const activeProvider = integrations?.activeProvider;
  const activeModel = integrations?.activeModel;
  const activeEmbeddingProvider = integrations?.activeEmbeddingProvider;
  const activeEmbeddingModel = integrations?.activeEmbeddingModel;

  return (
    <div className="h-screen h-dvh overflow-hidden flex flex-row bg-bg-gradient-dash">
      <Sidebar user={user} organization={organization} organizations={[]} />
      <div className="flex-1 overflow-y-auto flex flex-col items-center">
        <div className="w-full max-w-[768px] flex flex-col gap-6">

          {/* Header */}
          <div className="flex flex-col gap-1 pt-4">
            <h1 className="font-schibsted font-medium text-[20px] leading-6 text-black-0">Integrations</h1>
            <p className="font-schibsted font-normal text-[12px] leading-5 text-grey-60">Set organization-level secrets for AI providers</p>
          </div>

          {slackCallbackError && (
            <div className="bg-red-light border border-red-strong/20 rounded-lg p-4 flex items-center justify-between gap-3">
              <p className="text-sm text-red-strong">{slackCallbackError}</p>
              <button onClick={() => setSlackCallbackError('')} className="text-red-strong hover:underline text-sm font-medium">Dismiss</button>
            </div>
          )}

          {isLoading ? (
            <div className="flex justify-center items-center py-8">
              <div className="w-6 h-6 border-2 border-grey-40 border-t-brand rounded-full animate-spin" />
            </div>
          ) : (
            <>
              {/* Models */}
              <div className="flex flex-col gap-2">
                <p className="font-schibsted font-semibold text-[16px] leading-6 text-black-0">Models</p>
                <div className="flex flex-row gap-6 items-start">
                    {/* Default AI model */}
                    {enabledProviders.length > 0 && (
                      <div className="flex flex-col gap-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <p className="font-schibsted font-medium text-[14px] leading-6 text-grey-60">Default AI model</p>
                          <Tooltip
                            content="The default model used for analysis and reasoning across the app."
                            placement="bottom"
                            align="start"
                          >
                            <button
                              type="button"
                              className="inline-flex items-center justify-center"
                              aria-label="What is the default AI model?"
                            >
                              <InfoIcon />
                            </button>
                          </Tooltip>
                        </div>
                        <div className="relative w-fit" ref={modelDropdownRef}>
                          <button
                            onClick={() => setModelDropdownOpen(!modelDropdownOpen)}
                            className="inline-flex items-center gap-2 bg-white border border-grey-30 rounded-lg px-3 py-1 hover:border-grey-40 transition-colors"
                          >
                            {activeProvider && <ProviderIcon provider={activeProvider} size={16} />}
                            <span className="font-schibsted font-medium text-[14px] leading-6 text-black-0 tracking-[-0.5px]">
                              {activeModel || 'Select model'}
                            </span>
                            <ChevronDownIcon />
                          </button>

                          {modelDropdownOpen && (
                            <div className="absolute top-full left-0 mt-1 bg-white border border-grey-30 rounded-lg shadow-lg z-50 min-w-[240px] py-1 max-h-[300px] overflow-y-auto">
                              {enabledProviders.map((pName) => {
                                const models = modelsForProvider(pName);
                                if (models.length === 0) return null;
                                return (
                                  <div key={pName}>
                                    <div className="px-3 py-1.5 flex items-center gap-1.5">
                                      <ProviderIcon provider={pName} size={14} />
                                      <span className="font-schibsted font-semibold text-[11px] text-grey-60 uppercase tracking-wide">{PROVIDER_META[pName]?.label}</span>
                                    </div>
                                    {models.map((m) => (
                                      <button
                                        key={`${pName}-${m.id}`}
                                        onClick={() => handleSelectDefault(pName, m.id)}
                                        className={`w-full text-left px-3 py-1.5 font-schibsted text-[13px] leading-5 hover:bg-grey-10 transition-colors flex items-center justify-between ${activeProvider === pName && activeModel === m.id ? 'text-black-0 font-medium bg-grey-10' : 'text-grey-60'}`}
                                      >
                                        <span className="pl-5">{m.name}</span>
                                        {activeProvider === pName && activeModel === m.id && <CheckIcon />}
                                      </button>
                                    ))}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Text embedding model */}
                    <div className="flex flex-col gap-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <p className="font-schibsted font-medium text-[14px] leading-6 text-grey-60">Text embedding model</p>
                        <Tooltip
                          content="Used for topic clustering axis positioning."
                          placement="bottom"
                          align="start"
                        >
                          <button
                            type="button"
                            className="inline-flex items-center justify-center"
                            aria-label="What is the text embedding model?"
                          >
                            <InfoIcon />
                          </button>
                        </Tooltip>
                      </div>

                      {enabledEmbeddingProviders.length > 0 ? (
                        <div className="relative w-fit" ref={embeddingDropdownRef}>
                          <button
                            onClick={() => setEmbeddingDropdownOpen(!embeddingDropdownOpen)}
                            className="inline-flex items-center gap-2 bg-white border border-grey-30 rounded-lg px-3 py-1 hover:border-grey-40 transition-colors"
                          >
                            {activeEmbeddingProvider && <ProviderIcon provider={activeEmbeddingProvider} size={16} />}
                            <span className="font-schibsted font-medium text-[14px] leading-6 text-black-0 tracking-[-0.5px]">
                              {activeEmbeddingModel || 'Select embedding model'}
                            </span>
                            <ChevronDownIcon />
                          </button>

                          {embeddingDropdownOpen && (
                            <div className="absolute top-full left-0 mt-1 bg-white border border-grey-30 rounded-lg shadow-lg z-50 min-w-[280px] py-1 max-h-[300px] overflow-y-auto">
                              {enabledEmbeddingProviders.map((pName) => {
                                const models = embeddingModelsForProvider(pName);
                                if (models.length === 0) return null;
                                return (
                                  <div key={pName}>
                                    <div className="px-3 py-1.5 flex items-center gap-1.5">
                                      <ProviderIcon provider={pName} size={14} />
                                      <span className="font-schibsted font-semibold text-[11px] text-grey-60 uppercase tracking-wide">{PROVIDER_META[pName]?.label}</span>
                                    </div>
                                    {models.map((m) => (
                                      <button
                                        key={`emb-${pName}-${m.id}`}
                                        onClick={() => handleSelectEmbedding(pName, m.id)}
                                        className={`w-full text-left px-3 py-1.5 font-schibsted text-[13px] leading-5 hover:bg-grey-10 transition-colors flex items-center justify-between ${activeEmbeddingProvider === pName && activeEmbeddingModel === m.id ? 'text-black-0 font-medium bg-grey-10' : 'text-grey-60'}`}
                                      >
                                        <span className="pl-5">{m.name}</span>
                                        {activeEmbeddingProvider === pName && activeEmbeddingModel === m.id && <CheckIcon />}
                                      </button>
                                    ))}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="inline-flex items-center gap-2 bg-grey-10 border border-grey-20 rounded-lg px-3 py-1.5 w-fit">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                          </svg>
                          <span className="font-schibsted font-normal text-[13px] leading-5 text-grey-60">
                            Using built-in embeddings (no API key required)
                          </span>
                        </div>
                      )}
                    </div>
                </div>
              </div>

              {/* AI providers */}
              <div className="flex flex-col">
                <p className="font-schibsted font-semibold text-[16px] leading-6 text-black-0">AI providers</p>
                <div className="flex flex-wrap gap-3 py-3">
                  {PROVIDER_ORDER.map((providerName) => {
                    const meta = PROVIDER_META[providerName];
                    const enabled = isProviderEnabled(providerName);
                    const isActive = activeProvider === providerName;

                    return (
                      <div
                        key={providerName}
                        className={`w-[236px] flex flex-col gap-3 rounded-xl border border-[#e7ebee] overflow-hidden p-4 ${enabled ? 'bg-grey-20' : 'bg-white'}`}
                      >
                        {/* Card header */}
                        <div className="flex flex-col gap-1">
                          <div className="flex items-center gap-1 w-full">
                            <ProviderIcon provider={providerName} size={16} />
                            <span className="flex-1 font-schibsted font-medium text-[14px] leading-6 text-black-0">{meta.label}</span>
                            {enabled && <CheckIcon />}
                          </div>
                          <p className="font-schibsted font-normal text-[12px] leading-5 text-grey-60">{meta.description}</p>
                        </div>

                        {/* Card actions */}
                        {enabled ? (
                          <div className="flex gap-2 w-full">
                            <button
                              onClick={() => setModalProvider(providerName)}
                              className="flex-1 h-8 flex items-center justify-center bg-white border border-grey-30 rounded-lg font-schibsted font-medium text-[14px] leading-6 text-black-0 tracking-[-0.5px] hover:bg-grey-10 transition-colors"
                            >
                              Update
                            </button>
                            <button
                              onClick={() => handleDisableProvider(providerName)}
                              className="flex-1 h-8 flex items-center justify-center bg-white border border-grey-30 rounded-lg font-schibsted font-medium text-[14px] leading-6 text-[#e50026] tracking-[-0.5px] hover:bg-red-light transition-colors"
                            >
                              Disable
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => setModalProvider(providerName)}
                            className="w-full h-8 flex items-center justify-center bg-white border border-grey-30 rounded-lg font-schibsted font-medium text-[14px] leading-6 text-black-0 tracking-[-0.5px] hover:bg-grey-10 transition-colors"
                          >
                            Configure
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {organization && modalProvider && (
        <AIProviderModal
          isOpen={!!modalProvider}
          onClose={() => setModalProvider(null)}
          organizationId={organization._id || organization.id}
          providerName={modalProvider}
          models={modelCatalog[modalProvider] || []}
          onSuccess={() => { fetchIntegrations(); setModalProvider(null); }}
        />
      )}
    </div>
  );
};

export default Integrations;
